import { connect } from 'react-redux'
import { IDispatchProps, Welcome } from './Welcome'
import { reLocate } from '../../common/Routes/RouterActions'
import { IGlobalState } from '../../Root/store/appReducer'
import { IStateProps } from '../Login/Login'
import { getUserDto, isAuthenticated, isResetPasswordInProgress } from '../../common/auth/authSelectors'

const mapStateToProps = (state: IGlobalState): IStateProps => ({
  authenticated: isAuthenticated(state),
  resetPasswordInProgress: isResetPasswordInProgress(state),
  userDto: getUserDto(state),
})

const mapDispatchToProps: IDispatchProps = {
  reLocate,
}

export default connect(mapStateToProps, mapDispatchToProps)(Welcome)
